export interface AuthenticationConfig {
  loginApi: string;
  logoutApi: string;
  checkAuthApi: string;
}

const authenticationConfig: AuthenticationConfig = {
  loginApi: '/authentication/staff/login',
  logoutApi: '/authentication/staff/logout',
  checkAuthApi: '/authentication/staff/check',
};

export default authenticationConfig;
